/** HKDF-SHA256 derivations with fixed, namespaced info strings. */
import { hkdf } from "@noble/hashes/hkdf.js";
import { sha256 } from "@noble/hashes/sha2.js";
import { frame, u64be, utf8 } from "./bytes.js";
export const INFO = {
    ecies: utf8("tether/v1/ecies"),
    segment: utf8("tether/v1/segment"),
    metadataRecord: utf8("tether/v1/meta"),
};
export function derive(ikm, salt, info, length = 32) {
    return hkdf(sha256, ikm, salt, info, length);
}
/** Per-segment key from a window key. Deterministic; distinct per (streamId, seq). */
export function segmentKey(windowKey, streamId, seq) {
    if (windowKey.length !== 32)
        throw new Error("window key must be 32 bytes");
    return derive(windowKey, undefined, frame(INFO.segment, utf8(streamId), u64be(seq)));
}
//# sourceMappingURL=kdf.js.map